import { isCapabilityEnabled } from 'owa-capabilities';
import { newHeaderCapability } from 'owa-capabilities-definitions/lib/newHeaderCapability';
import { getDrawerPaneWidth } from 'owa-drawer';
import { getFlexPaneWidth } from 'owa-suite-header-store';

export const updateFlexPaneInternalWidth = (
    flexPaneId?: string,
    targetWindow: Window = window
): void => {
    const width = isCapabilityEnabled(newHeaderCapability)
        ? getDrawerPaneWidth(flexPaneId, targetWindow)
        : getFlexPaneWidth(flexPaneId);

    targetWindow.document.documentElement.style.setProperty('--flexPaneWidth', `${width}px`);
};
